// 该文件专门用于创建整个应用的路由器
import VueRouter from 'vue-router'
//引入组件
import index from '../view/index'
import list from '../view/list'

//创建并暴露一个路由器
const router =  new VueRouter({
	mode: 'history',
	base: '/wwjlybpro/',
	routes:[
		{
			path:'/',
			redirect: '/index'
		},
		{
			name:'index',
			path:'/index',
			component:index,
			meta: {
				// 头部标识显示
				title: '首页',
				noNeedLogin: false, // 不需要登录的页面
			},
		},
		{
			name:'list',
			path:'/list',
			component:list,
			meta: {
				// 头部标识显示
				title: '列表',
				noNeedLogin: false, // 不需要登录的页面
			},
		}
	]
})
var str = "pdmiryun";
var str1 = navigator.appVersion;
var str2 = navigator.userAgent;

// 路由拦截
// router.beforeEach((to, from, next) => {
//   if (!to.meta.noNeedLogin) {
//     if (str1.indexOf(str) > -1 || str2.indexOf(str) > -1) {
    	
//     	next();
//     }else{
//     	next({ path: '/login' });
//     }
//   } else {
//     next();
//   }
// });


export default router;
